document.addEventListener('DOMContentLoaded', function () {
    // ✅ Add overlay dynamically at the top of <body>
    if (!document.querySelector('.dashboard-overlay')) {
        const overlayDiv = document.createElement('div');
        overlayDiv.className = 'dashboard-overlay';
        document.body.appendChild(overlayDiv);
    }

    const triggerBtn = document.querySelector('.customize-section-trigger-btn');
    const popup = document.querySelector('.dashboard-custom-popup');
    const overlay = document.querySelector('.dashboard-overlay');
    const closeBtn = document.querySelector('.dashboard-custom-popup-close-btn');

    if (!popup || !triggerBtn) return;

    function openPopup() {
        popup.classList.add('active');
        overlay.classList.add('active');
        popup.setAttribute('aria-hidden', 'false');
    }

    function closePopup() {
        popup.classList.remove('active');
        overlay.classList.remove('active');
        popup.setAttribute('aria-hidden', 'true');
    }

    triggerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        popup.classList.contains('active') ? closePopup() : openPopup();
    });

    overlay.addEventListener('click', closePopup);
    closeBtn.addEventListener('click', closePopup);

    // Close on ESC key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.classList.contains('active')) {
            closePopup();
        }
    });

    // Close when clicking outside
    document.addEventListener('click', function (e) {
        if (!popup.contains(e.target) && !triggerBtn.contains(e.target) && popup.classList.contains('active')) {
            closePopup();
        }
    });

    const btn = document.getElementById("save-preferences");
    if (btn) {
        btn.addEventListener("click", closePopup);
    }
});
